<template>
  <r-panel :disabled="disabled" :title="title">
    <r-reward-view :model.sync="value"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";

import RRewardView from "@/modules/redactor/views/reward/r-reward-view.vue";
import RPanel from "@/modules/redactor/views/utils/r-panel.vue";

export default {
  name: "r-reward-panel",
  components: {RPanel, RRewardView},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Reward"),
    model: VueTypes.instanceOf(RewardModel)
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new RewardModel();
        this.$emit("update:model", value);
        return value;
      }
    }
  }
}
</script>